var Component = require("!../../../../_vue-loader@11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../_vue-loader@11.3.4@vue-loader/lib/selector?type=script&index=0!./pager.vue"),
  /* template */
  require("!!../../../../_vue-loader@11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-64fb1d62\",\"transformToRequire\":{\"audio\":\"src\"}}!../../../../_vue-loader@11.3.4@vue-loader/lib/selector?type=template&index=0!./pager.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/_vue-easytable@1.7.2@vue-easytable/libs/v-pagination/src/pager.vue
// module id = 918
// module chunks = 116